const getContentfulEnvironment = () => {
  return process.env.REACT_APP_CONTENTFUL_ENVIRONMENT ??
    process.env.NODE_ENV === "production"
    ? "master"
    : "staging";
};

export default getContentfulEnvironment;
